const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

const includes = [
  'Small intimate group',
  'Fully held by Mandie',
  'Somatic practices and psychological work',
  'Beautiful location',
  'Nourishing meals and sacred space',
];

export default function Offer4Section() {
  return (
    <section className="relative bg-[#1A1A1A] py-20 md:py-32 lg:py-40 overflow-hidden">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20serene%20retreat%20villa%20nestled%20in%20nature%20with%20warm%20golden%20sunlight%2C%20terracotta%20and%20cream%20exterior%20architecture%20with%20Mediterranean%20influences%2C%20surrounded%20by%20gentle%20hills%20and%20olive%20trees%2C%20soft%20evening%20light%20with%20long%20shadows%2C%20peaceful%20healing%20destination%2C%20editorial%20travel%20photography%20with%20warm%20earth%20tones%20and%20dreamy%20atmosphere%2C%20safe%20sacred%20gathering%20space%2C%20high%20detail%20wide%20landscape%20composition&width=1600&height=900&seq=offer4-retreat-2026-v2&orientation=landscape"
          alt="Beautiful retreat villa for women's healing immersion with Mandie Ozee"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/90 via-[#1A1A1A]/65 to-[#1A1A1A]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto text-center">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
          Immersive healing experience
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-6 leading-tight">
          Some healing can only happen when you leave your life behind.
        </h2>

        {/* Body */}
        <p className="font-body text-sm md:text-base text-[#E8E8E8] leading-relaxed mb-8 max-w-2xl mx-auto">
          Once a year, Mandie gathers a small curated group of women in a beautiful location. These are not holidays. They are turning points. Structured, clinically held, deeply intentional.
        </p>

        {/* Includes */}
        <ul className="space-y-3 mb-10 inline-block text-left">
          {includes.map((item) => (
            <li key={item} className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0" />
              <span className="font-body text-sm text-[#E8E8E8]">{item}</span>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 whitespace-nowrap"
          >
            Book a spot
          </a>
<p className="text-xs text-[#4A4A4A] mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#D4006A]">Book a Private Clarity Call</a>
</p>
        </div>
      </div>
    </section>
  );
}